import { Card, Form, FloatingLabel, Modal } from 'react-bootstrap';
import { FC, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser, useGetIsDarkMode } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeModal: () => void;
    openAlertModalHandler: (title: string, message: string, animation?: number) => void;
    openConfirmModalHandler: (title: string, message: string, execution: Function) => void;
};

export const UserChangeEmail: FC<propsType> = ({ closeModal, openAlertModalHandler, openConfirmModalHandler }) => {
    const [newEmail, setNewEmail] = useState('');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const user = useGetCurrentUser();

    const changeEmailHandler = async (): Promise<void> => {
        if (newEmail.length < 6) {
            openAlertModalHandler("La dirección no tiene formato de dirección de correo electrónico", "");
            return;
        }
        openConfirmModalHandler(
            "Se va a cambiar la dirección de correo electrónico",
            `Pasará de ser ${user.email} a ${newEmail}. Recordar que esta dirección de Email va a ser también el 'nombre de usuario' para ingresar a la aplicación`,
            async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.ChangeMyEmail(newEmail);
                dispatch(hideLoadingModalReducer());
                dispatch(setAlertResponse({ response }));
                if (response.success) {
                    closeModal();
                }
            }
        );
    }

    return (
        <Modal
            centered
            fullscreen={'md-down'}
            onHide={closeModal}
            show
            size={'lg'}
        >
            <style>
                {'.btn-close { background-color: white; }'}
            </style>
            <Modal.Header className={'bg-dark text-white'} closeButton>
                <Modal.Title>
                    CAMBIAR LA DIRECCIÓN DE EMAIL
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'bg-lightdark text-white'}>
                <Card className={isDarkMode ? 'bg-dark text-white' : ''}
                    style={{ margin: '60px auto', maxWidth: '450px', padding: '25px' }}
                >
                    <Form.Group>
                        <FloatingLabel
                            label={"Dirección de Email actual"}
                            className={'mb-3 text-secondary'}
                        >
                            <Form.Control type={'text'}
                                placeholder={""}
                                value={user.email}
                                onChange={e => setNewEmail(e.target.value)}
                                disabled
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group>
                        <FloatingLabel className={'mb-3 text-secondary'}
                            label={"Nueva dirección de Email"}
                        >
                            <Form.Control type={'text'}
                                placeholder={""}
                                value={newEmail}
                                onChange={e => setNewEmail(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' ? changeEmailHandler() : null }
                                autoFocus
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <span className={'text-center my-2'}>
                        Esta dirección de Email va a ser también el "nombre de usuario" para ingresar a la aplicación
                    </span>
                    <button className={'btn btn-general-blue my-2'}
                        onClick={changeEmailHandler}
                        disabled={!newEmail || !generalHelpers.IsValidEmail(newEmail)}
                    >
                        Aceptar
                    </button>
                    <button className={'btn btn-general-red'} onClick={closeModal}>
                        Cancelar
                    </button>
                </Card>
            </Modal.Body>
        </Modal>
    );
}
